module.exports = __webpack_public_path__ + "static/media/search.ca55de8c.svg";